import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EmployeeDto } from '@api/models/employees/EmployeeDto';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { EntityState } from '@api/models/enums/EntityState';
import { employeeService } from '@api/services/services';

export interface EmployeeListFilter extends ListFilter {
  state?: EntityState;
  establishments: ReferenceDto[];
}

export type EmployeeListState = ListType<EmployeeDto, EmployeeListFilter>;

const initialState: EmployeeListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'lastName',
    sortDesc: false,
    establishments: [],
  },
};

export const employeeListSlice = listSlice({
  name: 'employeeList',
  initialState,
});

export const selectEmployeeList = (state: RootState) => state.employeeList;
export const employeeListActions = employeeListSlice.actions;

export const getEmployeeList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectEmployeeList(storeState);

  const handleGetData = (size: number) => {
    return employeeService.query(
      {
        q: data.query.q,
        state: data.query.state,
        establishments: data.query.establishments.map((x) => x.id),
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: employeeListActions,
    getData: handleGetData,
  });
};
